import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DPO_CONSTANT } from './../../utils/constant';
import { CsvService } from './../../services/csv.service';
import { TranslateService} from '@ngx-translate/core';   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
import { element } from 'protractor';		// CAP-20457 : DAAS-42 : Imported package

@Component({
  selector: 'app-operation-details-dialog-box',
  templateUrl: './operation-details-dialog-box.component.html',
  styleUrls: ['./operation-details-dialog-box.component.scss']
})
export class OperationDetailsDialogBoxComponent implements OnInit {

  // Define the properties of the component
  operationResult: any = {};
  operationTempList: Array<any> = [];             // CAP-20457 : DAAS-42 : Variable declaration
  operationList: Array<any> = [];

  displayedColumns: string[] = ['rrdi', 'vin', 'basketFolderNumber', 'prestation', 'appCode', 'brand', 'label', 'subscriptionDate', 'operationDate', 'executionDate'];
  dataSource = new MatTableDataSource(this.operationList);
  @ViewChild('paginator', { static: true }) paginator: MatPaginator;
  @ViewChild('sort', { static: true }) sort: MatSort;

  constructor(public dialogRef: MatDialogRef<OperationDetailsDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastrService: ToastrService,
    private csvService: CsvService,
    private translate:TranslateService   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
    ) { }

  ngOnInit() {
    // Prepare the data for operation data which are passed from calling component
    if (this.dataSource && this.dataSource.data && this.dataSource.data.length > 0) {
      this.dataSource.data.splice(0, this.operationList.length);
    }
    if (this.data && this.data.operationResult && this.data.operationList) {
      this.operationResult = this.data.operationResult;
      /* CAP-20457 : DAAS-42 : Start- Translations of label in detail screen */
      this.operationTempList = this.data.operationList;
      this.operationTempList.forEach(element=>{
        element.label = this.translate.instant(element.label);   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
        element.prestation = this.translate.instant(element.prestation);   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
      })
      this.operationList = this.operationTempList;
      /* CAP-20457 : DAAS-42 : END */
      this.intializeTable();
    }
  }

  // Initilize the table to it's initial state
  intializeTable() {
    this.dataSource = new MatTableDataSource(this.operationList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  // Method to close the dialog box
  close(): void {
    this.dialogRef.close();
  }

  // Method to export the data into CSV file
  export() {
    if (this.operationList && this.operationList.length > 0) {
      // Prepare the header for the CSV file
      //CAP-20457: LOT1.1: START -Translation Service changed to translate for JSON
      const csvHeaders = [
        this.translate.instant('dpo.i18n.table.header.rrdi'),
        this.translate.instant('dpo.i18n.table.header.vin'),
        this.translate.instant('dpo.i18n.table.header.backetFolderNumber'),
        this.translate.instant('dpo.i18n.table.header.feature'),
        this.translate.instant('dpo.i18n.table.header.ecu'),
        this.translate.instant('dpo.i18n.table.header.brand'),
        this.translate.instant('dpo.i18n.table.header.status'),
        this.translate.instant('dpo.i18n.table.header.subscription.date'),
        this.translate.instant('dpo.i18n.table.header.operation.date'),
        this.translate.instant('dpo.i18n.table.header.execution.date')
      ];
      //CAP-20457: LOT1.1: STOP - Translation Service changed to translate for JSON

      let operations = [];
      // Prepare the data for CSV file
      for (let operationData of this.operationList) {
        let operation = {};
        operation['rrdi'] = operationData['rrdi'] ? operationData['rrdi'] : '';
        operation['vin'] = operationData['vin'] ? operationData['vin'] : '';
        operation['basketFolderNumber'] = operationData['basketFolderNumber'] ? operationData['basketFolderNumber'] : '';
        operation['feature'] = operationData['prestation'] ? operationData['prestation'] : '';
        operation['ecu'] = operationData['appCode'] ? operationData['appCode'] : '';
        operation['brand'] = operationData['brand'] ? operationData['brand'] : '';
        operation['status'] = operationData['label'] ? operationData['label'] : '';
        operation['subscriptionDate'] = operationData['subscriptionDate'] ? operationData['subscriptionDate'] : '';
        operation['operationDate'] = operationData['operationDate'] ? operationData['operationDate'] : '';
        operation['executionDate'] = operationData['executionDate'] ? operationData['executionDate'] : '';
        operations.push(operation);
      }

      // Call save method of CSV Service to save the CSV file
      this.csvService.save(csvHeaders, operations, DPO_CONSTANT.OPERATION_EXPORT_FILENAME);
    } else {
      this.toastrService.warning(this.translate.instant('dpo.i18n.message.export.empty'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
    }
  }

}
